// ─── Event constants ───────────────────────────────────────────────────────
// Change these values here and every page / calendar link updates automatically.

// 2:00 PM Eastern Daylight Time (UTC-4) — August 1, 2026
export const EVENT_DATE        = new Date('2026-08-01T14:00:00-04:00');
// Informal end — ~8 hours later (dinner + evening hang)
export const EVENT_END_DATE    = new Date('2026-08-01T22:00:00-04:00');

export const RSVP_DEADLINE     = new Date('2026-07-22T23:59:59-04:00');

export const EVENT_TITLE       = `CanAm Games ${EVENT_DATE.getFullYear()}`;
export const EVENT_DESCRIPTION = 'Annual CanAm Event — Team USA vs Team Canada!';
export const EVENT_LOCATION    = '137 Northington Dr., East Amherst, NY 14051';
